<template>
  <el-row v-if="blogAbout !== null" class="movie-list">
    <el-col :md="12">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{ blogAbout.title }}</span>
        </div>
        <div class="text item">
          {{ blogAbout.content }}
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { getAbout } from '@/api/blog'

export default {
  name: 'AboutPage',
  data() {
    return {
      blogAbout: null
    }
  },
  created() {
    document.title = '关于'
    this.getData()
  },
  methods: {
    getData() {
      getAbout().then(resp => {
        if (resp.code === 0) {
          this.blogAbout = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding: 5px;
  }
}

.movie-list {
  padding: 5px;
}
</style>
